<template>
  <main id="account" class="page-container">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="errorMessage2"
      :class="{ 'error-message': true, show: errorMessage2 }"
    >
      {{ errorMessage2 }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p>
    <p
      v-if="successMessage2"
      :class="{ 'success-message': true, show: successMessage2 }"
    >
      {{ successMessage2 }}
    </p> -->

    <!-- Form principale -->
    <form class="create-account-form" @submit.prevent="handleSubmit">
      <!-- RIGA 1: account email, old/new password -->
      <div class="change-password-section">
        <h3>Cambia password</h3>
        <div class="create-account-row row-1">
          <div class="field">
            <label for="account-email1">Email</label>
            <input
              id="account-email1"
              type="email"
              placeholder="Indirizzo email"
              v-model="emailStep1"
              autocomplete="email"
              required
            />
          </div>

          <div class="field" v-if="step === 1">
            <!-- Vecchia Password -->
            <label v-if="step === 1" for="old-password">Vecchia Password</label>
            <div class="account-password-field">
              <input
                v-if="step === 1"
                id="old-password"
                :type="showPassword1 ? 'text' : 'password'"
                placeholder="Inserisci vecchia password"
                v-model="oldPassword"
                autocomplete="current-password"
                required
              />

              <!-- Occhio (o icona) per mostrare/nascondere la password -->
              <button
                type="button"
                class="toggle-password-button"
                @click="togglePassword1"
              >
                <!-- Se showPassword è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
                <span v-if="!showPassword1">
                  <font-awesome-icon :icon="['fas', 'eye-slash']" />
                </span>
                <span v-else>
                  <font-awesome-icon :icon="['fas', 'eye']" />
                </span>
              </button>
            </div>
          </div>

          <div class="field" v-if="step === 2">
            <!-- Nuova Password -->
            <label v-if="step === 2" for="account-password1"
              >Nuova Password</label
            >
            <div class="account-password-field">
              <input
                v-if="step === 2"
                id="account-password1"
                :type="showPassword2 ? 'text' : 'password'"
                placeholder="Inserisci nuova password"
                v-model="newPasswordStep2"
                autocomplete="new-password"
                required
              />

              <!-- Occhio (o icona) per mostrare/nascondere la password -->
              <button
                type="button"
                class="toggle-password-button"
                @click="togglePassword2"
              >
                <!-- Se showPassword è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
                <span v-if="!showPassword2">
                  <font-awesome-icon :icon="['fas', 'eye-slash']" />
                </span>
                <span v-else>
                  <font-awesome-icon :icon="['fas', 'eye']" />
                </span>
              </button>
            </div>
          </div>

          <div class="save-button-container">
            <button type="submit" id="change-password">
              {{
                step === 1 ? "Verifica vecchia password" : "Aggiorna password"
              }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <form class="create-account-form" @submit.prevent="createNewAdmin">
      <!-- RIGA 2: account email, password -->
      <div class="create-account-section">
        <h3>Aggiungi un nuovo utente amministratore</h3>
        <div class="create-account-row row-2">
          <div class="field">
            <!-- account email -->
            <label for="account-email2">Aggiungi admin</label>
            <input
              id="account-email2"
              type="email"
              placeholder="Indirizzo email"
              v-model="emailAdmin"
              autocomplete="email"
              required
            />
          </div>

          <div class="field">
            <!-- password -->
            <label for="get-password">Password</label>
            <div class="account-password-field">
              <input
                id="get-password"
                :type="showAdminPassword ? 'text' : 'email'"
                placeholder="Password"
                v-model="passwordAdmin"
                autocomplete="current-password"
                required
              />

              <!-- Occhio (o icona) per mostrare/nascondere la password -->
              <button
                type="button"
                class="toggle-password-button"
                @click="toggleAdminPassword"
              >
                <!-- Se showPassword è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
                <span v-if="!showAdminPassword">
                  <font-awesome-icon :icon="['fas', 'eye-slash']" />
                </span>
                <span v-else>
                  <font-awesome-icon :icon="['fas', 'eye']" />
                </span>
              </button>
            </div>
          </div>

          <div class="save-button-container">
            <button id="add-admin" type="submit">Aggiungi admin</button>
          </div>
        </div>
      </div>
    </form>

    <div class="google-calendar-section">
      <h3>Google Calendar aziendale</h3>
      <p v-if="isGoogleCalendarConnected" class="google-status connected">
        <font-awesome-icon :icon="['fas', 'circle-check']" />
        Calendario aziendale collegato
      </p>
      <p v-else class="google-status">Calendario aziendale non collegato</p>
      <a
        v-if="canConnectGoogleCalendar"
        :href="googleAuthUrl"
        class="primary-btn google-connect-btn"
      >
        {{
          isGoogleCalendarConnected
            ? "Ricollega calendario aziendale"
            : "Collega calendario aziendale"
        }}
      </a>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      operatorName: "",
      step: 1, // Step iniziale
      emailStep1: "",
      oldPassword: "",
      newPasswordStep2: "",
      emailAdmin: "",
      passwordAdmin: "",
      errorMessage: "",
      errorMessage2: "",
      // successMessage: "",
      // successMessage2: "",
      role: "ceo",
      showPassword1: false, // controlla se la password è visibile
      showPassword2: false,
      showAdminPassword: false,
    };
  },
  computed: {
    ...mapGetters(["google/calendar/connected", "google/calendar/canConnect"]),
    isGoogleCalendarConnected() {
      return this["google/calendar/connected"];
    },
    canConnectGoogleCalendar() {
      return this["google/calendar/canConnect"];
    },
    googleAuthUrl() {
      return `${process.env.VUE_APP_API_URL}/auth/google`;
    },
  },
  mounted() {
    this.checkGoogleCalendarStatus();
    const params = new URLSearchParams(window.location.search);
    if (params.get("googleConnected") === "true") {
      this.checkGoogleCalendarStatus();
      this.toast.success("Google Calendar collegato con successo!");
      window.history.replaceState({}, "", window.location.pathname);
    }
  },
  methods: {
    ...mapActions(["checkGoogleCalendarStatus"]),
    togglePassword1() {
      // Inverte lo stato showPassword1
      this.showPassword1 = !this.showPassword1;
    },
    togglePassword2() {
      // Inverte lo stato showPassword2
      this.showPassword2 = !this.showPassword2;
    },
    toggleAdminPassword() {
      // Inverte lo stato showAdminPassword
      this.showAdminPassword = !this.showAdminPassword;
    },
    async handleSubmit() {
      this.errorMessage = "";
      if (this.step === 1) {
        // Step 1: Verifica Vecchia Password
        try {
          const payload = {
            email: this.emailStep1,
            password: this.oldPassword,
          };
          const response = await this.$axios.post(
            "/auth/verify-password",
            payload
          );
          if (response.status === 200) {
            this.step = 2; // Passa allo step 2
            this.$nextTick(() => {
              // this.successMessage =
              this.toast.success(
                "Password verificata! Inserisci la nuova password."
              );
            });
          } else {
            this.$nextTick(() => {
              // this.errorMessage =
              this.toast.error(
                response.data.details || "Email/password non corretti"
              );
            });
            // this.successMessage = "";
          }
        } catch (error) {
          this.$nextTick(() => {
            // this.errorMessage =
            this.toast.error(
              error.response?.data?.details || "Errore durante la verifica."
            );
          });
          // this.successMessage = "";
          // console.error("Errore durante la verifica password:", error);
        }
      } else if (this.step === 2) {
        // Step 2: Aggiorna Nuova Password
        try {
          const payload = {
            email: this.emailStep1,
            password: this.newPasswordStep2,
          };
          const response = await this.$axios.patch(
            "/auth/change-password",
            payload
          );
          if (response.status === 200) {
            // this.successMessage2 = "";
            this.step = 1;
            // this.$nextTick(() => {
            // this.successMessage2 =
            this.toast.success(
              response.data.details || "Password aggiornata con successo!"
            );
            // });
            this.emailStep1 = "";
            this.emailAdmin = "";
            // this.errorMessage2 = "";
            this.oldPassword = "";
            this.newPasswordStep2 = "";
          } else {
            // this.$nextTick(() => {
            // this.errorMessage2 =
            this.toast.error(
              response.data.details || "Password già aggiornata alla modifica"
            );
            // });
            // this.successMessage2 = "";
          }
        } catch (error) {
          // this.$nextTick(() => {
          // this.errorMessage2 =
          this.toast.success(
            error.response?.data?.details || "Errore durante l'aggiornamento."
          );
          // });
          // this.successMessage2 = "";
          // console.error("Errore durante l'aggiornamento password:", error);
        }
      }
    },
    async createNewAdmin() {
      // this.errorMessage = "";
      // this.successMessage = "";
      try {
        const payload = {
          operatorName: this.operatorName,
          email: this.emailAdmin,
          password: this.passwordAdmin,
          role: this.role,
        };
        const response = await this.$axios.post("/auth/create-admin", payload);
        if (response.status === 200) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data.message || "Operatore creato con successo!"
          );
          // });
          this.emailAdmin = "";
          // this.errorMessage = "";
          this.passwordAdmin = "";
        } else {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            response.data.message ||
              "Errore durante la creazione dell'operatore RESPONSE != 200."
          );
          // });
          // this.successMessage = "";
        }
      } catch (error) {
        // this.$nextTick(() => {
        // this.errorMessage =
        this.toast.error(
          error.response?.data?.details ||
            "Errore durante la creazione dell'operatore."
        );
        // });
        // this.successMessage = "";
        // console.error(
        //   "Errore durante la creazione dell'operatore CATCH:",
        //   error
        // );
      }
    },
  },
};
</script>

<style src="@/css/AccountPage.css"></style>
